import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-add",
  "use": "vab-icon-add-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-add\">\n<path d=\"M6.25 13C6.25 13.4142 6.58577 13.75 7 13.75C7.41423 13.75 7.75 13.4142 7.75 13V7.75H13C13.4142 7.75 13.75 7.41423 13.75 7C13.75 6.58577 13.4142 6.25 13 6.25H7.75V1C7.75 0.58579 7.41423 0.25 7 0.25C6.58577 0.25 6.25 0.58579 6.25 1V6.25H1C0.58579 6.25 0.25 6.58577 0.25 7C0.25 7.41423 0.58579 7.75 1 7.75H6.25V13Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol